import { useState, useContext, useEffect } from 'react'

/** import library  */
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import {
  IonContent,
  IonPage,
  useIonAlert,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonRouterLink,
  SegmentChangeEventDetail,
  IonHeader,
  IonToolbar,
  useIonToast,
} from '@ionic/react'
import styled from 'styled-components'

/** StoreProvider import */
import { StoresContext } from '../../../provider/StoreProvider'

/** components import */
import {
  StyleIonHeader,
  TextStyle,
  FooterButtons,
  CustomSpacer,
  DetailContent,
  Chip,
  StyleIonInputNew,
  PagingContent,
  ParamOption,
} from '../../../components'
import { DivideLine, DivideLineBold } from '../../../components/atoms/divide'
import { CategoryTitle } from '../../home'
import { onCopyContent, onParams, PARAM_FILTER, PARAM_SORT } from '../../../common'

/** typescript interface **/
interface IonSegmentCustomEvent<T> extends CustomEvent<T> {
  detail: T
  target: HTMLIonSegmentElement
}

export const Sample: React.FC<RouteComponentProps> = observer(() => {
  const { homeStore, marketStore } = useContext(StoresContext)
  const detailStore = homeStore.mainStore
  const pagingStore = marketStore.salePagingStore
  const [sortType, setSortType] = useState<PARAM_SORT>(PARAM_SORT.LATEST)
  const [filterType, setFilterType] = useState(PARAM_FILTER.ALL)

  // ionic event
  const [presentAlert] = useIonAlert()
  const [presentToast] = useIonToast()

  // paging function
  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  useEffect(() => {
    onParams({
      store: pagingStore,
      sortType: sortType,
      filterType: filterType,
      filterName: 'type',
    })
  }, [sortType, filterType])

  const filterList = [
    {
      type: PARAM_FILTER.ALL,
      title: '전체보기',
    },
    {
      type: PARAM_FILTER.FAVORITE,
      title: '관심작품',
    },
  ]

  const sortList = [
    {
      type: 'LATEST',
      title: '최근 거래순',
    },
    {
      type: 'REMAIN',
      title: '잔여 조각순',
    },
    {
      type: 'END_DATE',
      title: '오래된 거래순',
    },
  ]

  // input function
  const [inputValues, setInputValues] = useState({
    inputDefault: '',
    inputBox: '',
    textareaDefault: '',
    textareaBox: '',
  })
  const { inputDefault, inputBox, textareaDefault, textareaBox } = inputValues

  const onChangeInput = (event: { target: { value: string | number; name: string | number } }) => {
    const { value, name } = event.target
    setInputValues({ ...inputValues, [name]: value })
  }

  // tab function
  const [listType, setListType] = useState<'TRADE' | 'HISTORY'>('TRADE')
  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
    setListType(e.detail.value === 'TRADE' ? 'TRADE' : 'HISTORY')
  }

  // button function
  const onClickBtn = () => {
    presentAlert({
      mode: 'md',
      header: `알림`,
      cssClass: 'custom-alert-alert ',
      buttons: [
        {
          text: '아니요',
          cssClass: 'alert-button-cancel',
        },
        {
          text: '네',
          cssClass: 'alert-button-confirm',
          handler: async () => {
            console.log('button test')
          },
        },
      ],
    })
  }

  // copy function
  const copyContent = 'https://chat.openai.com'

  return (
    <IonPage>
      {/* 공통 header */}
      <IonHeader>
        <StyleToolbar>
          <TextStyle type={'b_20'} color={'success_main'} style={{ paddingLeft: '18px' }}>
            {'헤더'}
          </TextStyle>
        </StyleToolbar>
      </IonHeader>
      {/**
       * type: 헤더 타입 - 'MAIN' | 'SUB' | 'MODAL' | 'NAV'
       * title: 헤더 타이틀
       * rightItem?: 아이콘 표시
       * subTitle?: 서브 타이틀
       * onDismiss?: 모달창 닫기 기능
       * href?: 뒤로가기 버튼 클릭시 이동할 주소
       */}
      <StyleIonHeader type={'MAIN'} title="메인" rightItem={'ALARM'} />
      <StyleIonHeader type={'SUB'} title="서브" subTitle={'subTitle'} />
      {/* ionic Content 선언 */}
      <IonContent>
        {/* 공통 Content component : data 오류 및 loading bar */}
        <DetailContent detailStore={detailStore}>
          <CustomSpacer spacing="25px" /> {/* 여백 or 라인  */}
          {/* 공통 sub title component */}
          <TextStyle type={'b_20'} color={'success_main'} style={{ paddingLeft: '18px' }}>
            {'공통 타이틀'}
          </TextStyle>
          <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
          <CategoryTitle href={'/market'}>판매 예정 작품</CategoryTitle>
          <CategoryTitle href={'/sellHistory'}>이전 매각 히스토리</CategoryTitle>
          <CustomSpacer spacing="25px" bottomLine={true} /> {/* 여백 or 라인  */}
          <CustomSpacer spacing="25px" /> {/* 여백 or 라인  */}
          {/* styled-components 용 div, css 선언 (필요에 따라 생성 및 추가) */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'공통 텍스트 ver.1'}
            </TextStyle>
            <SubContent>
              {/* 공통 text component  */}
              <TextStyle type={'b_28'} color={'primary_light'}>
                Sample
              </TextStyle>
              <TextStyle type={'m_28'} color={'primary_light'}>
                Sample
              </TextStyle>
              <TextStyle type={'r_18'} color={'primary_light'}>
                Sample
              </TextStyle>
              {/* styled-components 용 div, css 선언 (필요에 따라 생성 및 추가) */}
              <TextBox>
                <TextStyle type={'b_28'} color={'primary_light'}>
                  Sample
                </TextStyle>
                <TextStyle type={'m_28'} color={'primary_light'}>
                  Sample
                </TextStyle>
                <TextStyle type={'r_18'} color={'primary_light'}>
                  Sample
                </TextStyle>
              </TextBox>
            </SubContent>
          </SampleContainer>
          <CustomSpacer spacing="25px" /> {/* 여백 or 라인  */}
          <DivideLine /> {/* 기본 구분선  */}
          <CustomSpacer spacing="25px" /> {/* 여백 or 라인  */}
          {/* styled-components 용 div, css 선언 (필요에 따라 생성 및 추가) */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'공통 텍스트 ver.2'}
            </TextStyle>
            <SubContent2>
              {/* styled-components 용 div, css 선언 (필요에 따라 생성 및 추가) */}
              <TextBox>
                {/* 공통 text component  */}
                <TextStyle type={'b_28'} color={'primary_light'}>
                  Sample
                </TextStyle>
                <TextStyle type={'m_28'} color={'primary_light'}>
                  Sample
                </TextStyle>
                <TextStyle type={'r_18'} color={'primary_light'}>
                  Sample
                </TextStyle>
              </TextBox>
              {/* 여백 component */}
            </SubContent2>
          </SampleContainer>
          <DivideLine /> {/* 기본 구분선  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'공통 INPUT'}
            </TextStyle>
            <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
            <StyleIonInputNew
              type={'text'}
              placeholder={'inputDefault'}
              inputType={'INPUT'}
              onInput={onChangeInput}
              name={'inputDefault'}
            />
            <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
            <StyleIonInputNew
              type={'text'}
              placeholder={'inputBox'}
              inputType={'INPUT'}
              inputStyle={'BOX'}
              onInput={onChangeInput}
              name={'inputBox'}
            />
            <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
            <StyleIonInputNew
              type={'text'}
              placeholder={'textareaDefault'}
              inputType={'TEXTAREA'}
              onInput={onChangeInput}
              name={'textareaDefault'}
            />
            <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
            <StyleIonInputNew
              type={'text'}
              placeholder={'textareaBox'}
              inputType={'TEXTAREA'}
              inputStyle={'BOX'}
              onInput={onChangeInput}
              name={'textareaBox'}
            />
            <FooterButtons
              button={{
                color: 'dark',
                text: '입력 테스트',
                onClick: () =>
                  alert(
                    JSON.stringify({
                      inputDefault: inputDefault,
                      inputBox: inputBox,
                      textareaDefault: textareaDefault,
                      textareaBox: textareaBox,
                    }),
                  ),
              }}
            />
          </SampleContainer>
          <DivideLine /> {/* 기본 구분선  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'공통 CHIP'}
            </TextStyle>
            <CustomSpacer spacing="10px" /> {/* 여백 or 라인  */}
            <Chip type="blue">SAMPLE</Chip>
            <SampleChipWrap1>
              <Chip type="red">SAMPLE</Chip>
            </SampleChipWrap1>
            <SampleChipWrap2>
              <Chip type="lightBlue">SAMPLE</Chip>
            </SampleChipWrap2>
          </SampleContainer>
          <DivideLineBold /> {/* 굵은 구분선  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'TAB'}
            </TextStyle>
            <IonSegment color="dark" value={listType} onIonChange={(e) => onSegmentChange(e)}>
              <IonSegmentButton value="TRADE">
                <IonLabel>TAB1</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="HISTORY">
                <IonLabel>TAB2</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </SampleContainer>
          <CustomSpacer spacing="25px" />
          <DivideLineBold /> {/* 굵은 구분선  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'CONTENT COPY'}
            </TextStyle>
            <CustomSpacer spacing="10px" />
            <TextStyle type={'m_15'}>{`카피 주소 : ${copyContent}`}</TextStyle>
            <LinkBox
              onClick={() =>
                onCopyContent(presentToast, {
                  content: copyContent,
                  successMsg: '카피 성공!',
                  failureMsg: '카피 실패.',
                })
              }
            >
              <TextStyle type={'r_15'}>링크 복사하기</TextStyle>
            </LinkBox>
          </SampleContainer>
          <DivideLineBold /> {/* 굵은 구분선  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'ROUTER LINK'}
            </TextStyle>
            <IonRouterLink color={'dark'} href={`/sample`}>
              <LinkBox>
                <TextStyle type={'r_15'}>이동하기</TextStyle>
              </LinkBox>
            </IonRouterLink>
          </SampleContainer>
          <DivideLineBold /> {/* 굵은 구분선  */}
          <CustomSpacer spacing="25px" />
          {/* 공통 footer button component  */}
          <SampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'SINGLE BUTTON'}
            </TextStyle>
            <CustomSpacer spacing="25px" />
            <FooterButtons
              button={{
                color: 'dark',
                text: '구매 하기',
                onClick: () => onClickBtn(),
              }}
            />
            <CustomSpacer spacing="10px" />
            <TextStyle type={'b_20'} color={'success_main'}>
              {'DOUBLE BUTTON'}
            </TextStyle>
            <CustomSpacer spacing="25px" />
            <FooterButtons
              button={{ color: 'success', text: '구매 하기', onClick: () => onClickBtn() }}
              rightButton={{ color: 'dark', text: '구매하기', onClick: () => onClickBtn() }}
            />
          </SampleContainer>
        </DetailContent>
        <DivideLineBold /> {/* 굵은 구분선  */}
        {/* 공통 Paging component : data 오류 및 loading bar */}
        <SampleContainer>
          <PagingSampleContainer>
            <TextStyle type={'b_20'} color={'success_main'}>
              {'공통 PagingContent'}
            </TextStyle>
            {/* sort, filter component */}
            <ParamOption
              filterData={{
                filterList: filterList,
                filterType: filterType,
                setFilterType: setFilterType,
              }}
              sortData={{
                sortList: sortList,
                setSortType: setSortType,
              }}
            />
            {/* PagingContent 구현부 */}
            <PagingContent pagingStore={pagingStore} loadParam={{ data: { filter: filterType } }}>
              {pagingStore.list.map(
                (d, i) =>
                  i < 5 && (
                    <SampleCard key={i}>
                      <img
                        src={d.imageUri}
                        alt={'icon'}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null
                          currentTarget.src = 'https://ionicframework.com/docs/img/demos/thumbnail.svg'
                        }}
                      />
                      <div className="content-container">
                        <TextStyle type="b_13" color={'primary_light'}>
                          {d.artist}
                        </TextStyle>
                        <TextStyle type="b_15">{d.name}</TextStyle>
                        <CustomSpacer spacing="20px" />
                        <TextStyle type="b_18" color={'success_main'}>{`${d.saleCost.toLocaleString()} 원`}</TextStyle>
                      </div>
                    </SampleCard>
                  ),
              )}
            </PagingContent>
          </PagingSampleContainer>
        </SampleContainer>
      </IonContent>
    </IonPage>
  )
})

// styled-components 용 div, css
const SubContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const SubContent2 = styled.div`
  display: block;
  padding: 10px 10px;
`
const TextBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
const LinkBox = styled.div`
  margin: 30px 0;
  width: 100%;
  background-color: var(--ion-color-gray100);
  padding: 17px 8px 17px 23px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ion-icon {
    font-size: 24px;
  }
`

// 샘플 적용을 위한 임시 스타일 - 헤더
const StyleToolbar = styled(IonToolbar)`
  --background: var(--ion-color-white);
  --min-height: 45px;
  ion-title {
    padding: 0 0 0 5px;
  }
  ion-icon {
    font-size: 24px;
  }
`

// 샘플 적용을 위한 임시 스타일 - container
const SampleContainer = styled.div`
  padding: 25px 20px;
`

const PagingSampleContainer = styled.div`
  height: 400px;
`

// 샘플 적용을 위한 임시 스타일 - chip
const SampleChipWrap1 = styled.div`
  width: 50%;
`
const SampleChipWrap2 = styled.div`
  // min-width가 60px로 지덩되어있음
  width: 1%;
`

// 샘플 적용을 위한 임시 스타일 - card
const SampleCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  background-color: #f5f5f5;
  padding: 15px 15px;
  border-radius: 10px;
  img {
    width: 100px;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: 5px;
  }
  .content-container {
    width: 100%;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
  }
`
